export const agentHeading = [
  {
    header: "Agent Name",
    accessor: "name",
  },
  {
    header: "Agent Code",
    accessor: "code",
  },
  {
    header: "Contact Details",
    accessor: "contactDetails",
  },
  {
    header: "Collections",
    accessor: "collections",
  },
  {
    header: "Plan Collections",
    accessor: "collectionsPlan",
  },
  {
    header: "Type",
    accessor: "type",
  },
  {
    header: "Status",
    accessor: "status",
  },
];
